import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {LeftBar} from './leftBar/LeftBar';
import {Toast} from '../../../../../../components/toast/Toast';
import {observer} from 'mobx-react';
import {Main} from './main/Main';
import {MultipartyDashboardController} from '../../../MultipartyDashboardController';
import {GalleryBar} from './galleryBar/GalleryBar';
import {NwayJoinRequestBanner} from '../NwayJoinRequestBanner';
import {WaitingForHost} from '@techsee/techsee-nway-media-service-client/lib/components/WaitingForHost/WaitingForHost';

import './MiniDashboardLayoutStyles.scss';

type MiniDashboardLayoutProps = {
    controller: MultipartyDashboardController;
};

@observer
export class MiniDashboardLayout extends TechseeBaseComponent<MiniDashboardLayoutProps> {
    renderInternal(): JSX.Element {
        const {controller} = this.props;

        if (controller.waitingForHostApproval) {
            return (
                <WaitingForHost
                    message={controller.translate('REACT.NWAY.WAITING_FOR_HOST')}
                    logoUrl={controller.logoUrl}
                    poweredByLabel={controller.translate('DASHBOARD.VIEW.POWERED_BY_TECHSEE')}
                />
            );
        }

        const isMobileView = !controller.isDesktopView && controller.desktopSharingToMobile ? 'mobile-size' : '';

        return (
            <div className='mini-dashboard-root-layout'>
                <div className='mini-dashboard-middle-area'>
                    <LeftBar />
                    <div className={`mini-dashboard-main-content ${isMobileView}`}>
                        <Main controller={controller} />
                        <Toast message={controller.notificationMessage} duration={5000} />
                        <NwayJoinRequestBanner controller={controller} className='mini-dashboard-join-requests' />
                        {controller.showGallery &&
                            !controller.isDesktopView &&
                            controller.isPortrait &&
                            controller.desktopSharingToMobile && <GalleryBar isMobileView={true} />}
                    </div>
                    {controller.showGallery &&
                        ((controller.isDesktopView && controller.desktopSharingToMobile) ||
                            !controller.desktopSharingToMobile ||
                            !controller.isPortrait) && <GalleryBar isMobileView={false} />}
                </div>
            </div>
        );
    }
}
